import * as React from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { cn } from 'cn';
const Collapsible = CollapsiblePrimitive.Root;
const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;
const CollapsibleContent = React.forwardRef<React.ComponentRef<typeof CollapsiblePrimitive.CollapsibleContent>, React.ComponentPropsWithoutRef<typeof CollapsiblePrimitive.CollapsibleContent>>(({
  className,
  children,
  ...props
}, ref) => <CollapsiblePrimitive.CollapsibleContent ref={ref} className={cn('data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down overflow-hidden transition-all duration-200', className)} {...props}>
    {children}
  </CollapsiblePrimitive.CollapsibleContent>);
CollapsibleContent.displayName = 'CollapsibleContent';
export { Collapsible, CollapsibleContent, CollapsibleTrigger };